/*
 * © 2023 Vertafore, Inc. All rights reserved.
 * Reproduction and distribution without the written permission of Vertafore is prohibited.
 */
import React, { Component, ReactElement } from "react";
import { Container, Col, Row, Table } from "react-bootstrap";
import { RatingUnit } from "../../types/customTypes/ratModels";

interface Props {
  ratingUnit: RatingUnit | null;
}

export default class RatingUnitDetailsComponent extends Component<Props> {
  render = (): ReactElement => {
    return (
      <Container fluid id="company_details" className="m-2">
        <Row>
          <Col className="details_header wide">
            <h5>{this.props.ratingUnit?.name}</h5>
          </Col>
        </Row>
        <Table className="details-table" striped>
          <tbody>
            <tr>
              <td className="col-3">Rating Unit Id</td>
              <td>{this.props.ratingUnit?.id ?? "N/A"}</td>
            </tr>
            <tr>
              <td className="col-3">Line of Business</td>
              <td>{this.props.ratingUnit?.lineOfBusiness ?? "N/A"}</td>
            </tr>
            <tr>
              <td className="col-3">State</td>
              <td>{this.props.ratingUnit?.state ?? "N/A"}</td>
            </tr>
            <tr>
              <td className="col-3">Company Id</td>
              <td>{this.props.ratingUnit?.companyId ?? "N/A"}</td>
            </tr>
            <tr>
              <td className="col-3">Plan Id</td>
              <td>{this.props.ratingUnit?.planId ?? "N/A"}</td>
            </tr>
            {this.props.ratingUnit?.lineOfBusiness != null &&
              (this.props.ratingUnit.lineOfBusiness === "PERSONAL_AUTO" ||
                this.props.ratingUnit.lineOfBusiness === "HOMEOWNERS") && (
                <tr>
                  <td className="col-3">Supports Umbrella</td>
                  <td>
                    {this.props.ratingUnit.supportsUmbrella != null
                      ? this.props.ratingUnit.supportsUmbrella
                        ? "Yes"
                        : "No"
                      : "N/A"}
                  </td>
                </tr>
              )}
          </tbody>
        </Table>
      </Container>
    );
  };
}
